const sliderTypes = {
  MOVE_DOTS: 'MOVE_DOTS',
  NEXT_SLIDE: 'NEXT_SLIDE',
  PREVIOUS_SLIDE: 'PREVIOUS_SLIDE',
  LAST_SLIDE: 'LAST_SLIDE',
  RESET_SLIDE: 'RESET_SLIDE',
};

export default sliderTypes;
